<template>
	<div id="agent" v-loading='loading' class='gcardfr'>
		<el-row :gutter="0" class=''>
			<el-col :span='16'>
				<el-button size='small' type="primary" icon="el-icon-plus" @click='addAg'>{{ $t('merchant.add_vendor') }}</el-button>
				<!-- <el-button @click='batchDel' :disabled="sRows.length == 0" size='small' type='danger' plain>批量删除</el-button>     -->
			</el-col>
			<el-col :span='8'>
				<div class="glineflex">
					<label class="glinelb">{{ $t('merchant.vendor_name') }}：</label>
					<el-input @keyup.enter.native="indexget" v-model='agId' size='small' placeholder=""></el-input>
				</div>
			</el-col>
		</el-row>
		<!-- @selection-change="batchSelected" @row-click='rowClick' -->
		<el-table ref="multipleTable" class='gtbtop' tooltip-effect="dark" @row-click="rowClick" :data="tableData"
			style="width: 100%">
			<!-- <el-table-column
        type="selection"
        width="55">
      </el-table-column> -->
			<el-table-column prop="agentId" :label="$t('merchant.vendor_id')" width="">
			</el-table-column>
			<el-table-column prop="clientKey" label="ClientKey" width="">
			</el-table-column>
			<el-table-column prop="agentName" :label="$t('merchant.vendor_name')" width="140">
			</el-table-column>
			<el-table-column prop="parentName" :label="$t('merchant.super_vendor')" width="140">
			</el-table-column>
			<el-table-column prop="deviceNum" :label="$t('merchant.equipment_quantity')">
			</el-table-column>
			<el-table-column prop="merchantNum" :label="$t('merchant.merchant_numbers')" width="">
			</el-table-column>
			<el-table-column prop="createTime" :label="$t('app_createTime')" width="170">
			</el-table-column>
			<el-table-column prop="name" :label="$t('app_operation')" width="180">
				<!-- adminStatus -->
				<template slot-scope="scope">
					<el-button type='text' @click='toDetail(scope.row)'>{{ $t('app_detail') }}</el-button>
					<el-button v-if="!$isNmAdminType()" :disabled="$isDefaultMc(scope.row)" type='text'
						@click="importEq(scope.row)">{{ $t('terminal.import_btn') }}</el-button>
					<label class='opbline'>|</label>
					<el-button :disabled="$isDefaultMc(scope.row)" @click='delRow(scope.row.agentId)' type='text'
						class='opdcolor'>{{ $t('app_delete') }}</el-button>
				</template>
			</el-table-column>
		</el-table>

		<Pages class='gpages' :cpage='page' :ctotal="total" :config='pconfig'></Pages>

		<el-dialog class='gstdia' :title="$t('merchant.add_vendor')" :visible.sync="showDia">
			<el-form :model="aform">
				<el-form-item label="Client Key" :label-width="$formlbWidth">
					<el-input v-model="aform.clkey" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item :label="$t('merchant.vendor_name')" :label-width="$formlbWidth">
					<el-input v-model="aform.name" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item :label="$t('merchant.channel_contact')" :label-width="$formlbWidth">
					<el-input v-model="aform.contact" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item :label="$t('merchant.contact_number')" :label-width="$formlbWidth">
					<el-input v-model="aform.phone" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item v-if='$isAdminType()' :label="$t('merchant.super_vendor')" :label-width="$formlbWidth">
					<!-- <el-input v-model="aform.parentId" autocomplete="off"></el-input> -->
					<Merchant :config='sortMc'></Merchant>
				</el-form-item>
				<el-form-item :label-width="$formlbWidth">
					<el-button @click="closeDia">{{ $t("app_cancel") }}</el-button>
					<el-button :disabled="addAgRqsDis" type="primary" @click="addAgRqs">{{ $t("app_sure") }}</el-button>
				</el-form-item>
			</el-form>
			<!-- <div slot="footer" class="dialog-footer">        
      </div> -->
		</el-dialog>

		<EquipList :show='showdia1' :config='econfig'></EquipList>
	</div>
</template>

<style>

</style>

<script>
	import Pages from '@/components/Pages.vue'
	import EquipList from '@/components/EquipList.vue'
	import Merchant from '@/components/Merchant.vue'
	export default {
		data() {
			return {
				// sRows: [],  
				sortMc: {},
				econfig: {},
				showdia1: false,
				agId: '',
				pconfig: '',
				tableData: [],
				showDia: false,
				aform: {
					clkey: '',
					name: '',
					contact: '',
					phone: '',
					parentId: ''
				},
				page: 1,
				total: 0,
				loading: false
			}
		},
		components: {
			Pages,
			EquipList,
			Merchant
		},
		computed: {
			addAgRqsDis() {
				var form = this.aform
				var isMc = this.$isAdminType() ? form.parentId : true
				if (form.clkey && form.name && form.contact && form.phone && isMc) {
					return false
				} else {
					return true
				}
			}
		},
		methods: {
			initMc() {
				var _this = this
				this.sortMc = {
					vlkey: 'clientKey',
					size: 'small',
					value: '',
					callback: (vl) => {
						_this.aform.parentId = vl ? vl : ''
						_this.getList()
					}
				}
			},
			indexget() {
				this.page = 1
				this.getList()
			},
			importEq(row) {
				this.showdia1 = true
				var _this = this
				this.econfig = {
					agid: row.agentId,
					mcid: '',
					title: this.$t('merchant.import_devices_vendors'),
					callback: ids => {
						///
						if (ids) {
							this.$agentBindEq(row.agentId, ids, res => {
								_this.getList()
								_this.$message.success(res.message)
								_this.showdia1 = false
							}, () => {
								this.$message.error(res.message)
							})
						} else {
							_this.showdia1 = false
						}
					}
				}
			},
			rowClick(row, column) {
				if (column.label != this.$t('app_operation')) {
					this.toDetail(row)
				}
			},
			delRqs(id) {
				this.loading = true
				this.$delAgent(id, res => {
					this.loading = false
					if (res.status == 200) {
						this.getList()
					} else {
						this.$message.error(res.message)
					}
				}, '')
			},
			// batchDel () {
			//   var arr = []
			//   this.sRows.forEach(item => {
			//     arr.push(item.id)
			//   })
			//   this.delRow(arr.toString())
			// },
			delRow(aid) {
				this.$showMsgBox(this.$t('app_delete_question'), () => {
					this.delRqs(aid)
				}, '')
			},
			// rowClick (row, column) {
			//   if (column.label != '操作') {
			//     this.toDetail(row)
			//   }      
			// }, 
			closeDia() {
				this.showDia = false
				this.aform.id = ''
				this.aform.clkey = ''
				this.aform.token = ''
				this.aform.name = ''
				this.aform.contact = ''
				this.aform.phone = ''
				this.aform.parentId = ''
				this.initMc()
			},
			addAgRqs() {
				this.loading = true
				var form = this.aform
				this.$addAgent(form.clkey, form.name, form.contact, form.phone, form.parentId, res => {
					this.loading = false
					if (res.status == 200) {
						this.closeDia()
						this.getList()
					} else {
						this.$message.error(res.message)
					}
				}, () => {
					this.loading = false
				})
			},
			addAg() {
				this.showDia = true
				// this.$getAddAgentInfo(res => {
				//   if (res.status == 200) {
				//     this.showDia = true
				//     // this.aform.clkey = res.data
				//   } else {
				//     this.$message.error(res.message)
				//   }
				// }, '')
			},
			toDetail(row) {
				this.$router.push({
					path: '/agent/detail',
					query: {
						id: row.agentId
					}
				})
			},
			getList() {
				this.loading = true
				var agentName = this.agId ? this.agId : ''
				this.$agentList(this.page, this.$gRow, agentName, res => {
					this.loading = false
					if (res.status == 200) {
						// this.total = res.total
						this.total = res.total
						this.tableData = res.data
					} else {
						this.$message.error(res.message)
					}
				}, '')
			},
			// batchSelected (val) {
			//   this.sRows = val
			// }
		},
		mounted() {
			this.getList()
			var _this = this
			this.initMc()
			this.pconfig = {
				callback: page => {
					///
					_this.page = page
					_this.getList()
				}
			}

		}
	}
</script>
